module.exports = __webpack_public_path__ + "media/images/icons/google-maps-61156a6b181a42024ea3694f7e6f5fb7.svg";